const setFontFamily = (editor, { value: fontFamily }) => {
  editor.chain().focus().setMark('textStyle', { fontFamily }).run();
};

export default {
  'font:family': setFontFamily,
};
